<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr pt15 mb15">
          <div class="prdState">
            <div>
              <span class="inB bold pointC4">
                <i>{{ orderInfo.preorderDateStr | dateFormatter('.') }}</i>
              </span>
              <span class="inB">
                (주문번호 :
                <i>{{ orderInfo.preorderId }}</i>
                )
              </span>
            </div>
            <div class="ar">
              <!--<em class="state" v-if="orderInfo.saleType == 'RORT00GE'" :class="{ pointC1: orderInfo.dispStatus == 'releaseIng' }">{{ orderInfo.dispStatusNm }}</em>-->
              <em class="state" :class="{ pointC1: orderInfo.dispStatus == 'releaseIng' }">{{ orderInfo.dispStatusNm }}</em>
            </div>
          </div>
        </section>

        <section class="hr">
          <div class="prdList">
            <div class="prdItem xs">
              <div class="imgArea">
                <span class="img" @click="goProductDetail">
                  <img
                    :src="orderInfo.thumbnail ? orderInfo.thumbnail : '/img/error_image.jpg'"
                    :alt="orderInfo.productName"
                    onerror="this.src='/img/error_image.jpg';"
                  />
                </span>
              </div>
              <div class="infoArea">
                <div class="tit row2">
                  <span>{{ orderInfo.productName }}</span>
                </div>
                <div class="txtItem">
                  <span>{{ orderInfo.modelName }}</span>
                </div>
                <div class="price" v-if="orderInfo.saleType == 'RORT00GE'">
                  <span class="money">
                    월 렌탈료
                    <em>{{ orderInfo.rentalAmount | currency }}</em>
                    원 x {{ orderInfo.rentalPeriod }}개월
                  </span>
                </div>
                <div class="price" v-if="orderInfo.saleType == 'RORT00SE'">
                  <span class="money">
                    <em>{{ orderInfo.saleAmount | currency }}</em>
                    원
                  </span>
                </div>
              </div>
            </div>
            <div class="selectedOpt">
              <div class="txtOpt">
                <div class="opt" v-if="orderInfo.optionCode1Nm != ''">
                  <span class="item">옵션</span>
                  <span class="val">{{ orderInfo.optionCode1Nm }}</span>
                </div>
                <div class="opt" v-if="orderInfo.saleType == 'RORT00GE'">
                  <span class="item">렌탈기간</span>
                  <span class="val" style="margin-right: 5px;">
                    {{ orderInfo.releaseDateStr | dateFormatter('.') }}~{{ orderInfo.ownershipDate | dateFormatter('.') }}
                  </span>
                </div>
                <div class="opt" v-if="orderInfo.saleType == 'RORT00SE'">
                  <span class="item">수량</span>
                  <span class="val">1개</span>
                </div>
                <div class="opt" v-if="orderInfo.dispStatus == 'releaseComp'">
                  <span class="item">설치일</span>
                  <span class="val">{{ orderInfo.releaseDateStr | dateFormatter('.') }}</span>
                </div>
              </div>
            </div>
            <div class="btnArea nowrap">
              <button
                type="button"
                class="btn_s s"
                @click="goDelivery"
                :disabled="orderInfo.trackDeliveryYn != 'Y' || orderInfo.releaseClass == 'RDET0001'"
              >
                배송조회
              </button>
              <button type="button" class="btn_s s" @click="goContract" v-if="orderInfo.saleType == 'RORT00GE' || orderInfo.saleType == 'RORT00IS'">계약서</button>
              <!--<button type="button" class="btn_s s" @click="goNotice">유의사항</button>-->
            </div>
          </div>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">배송지 정보</h2>
          </div>
          <table class="tableY noLine bbNone">
            <colgroup>
              <col style="width:110px" />
              <col style="width:auto" />
            </colgroup>
            <tbody>
              <tr>
                <td class="th">이름</td>
                <td>{{ orderInfo.userName }}</td>
              </tr>
              <tr>
                <td class="th">핸드폰번호</td>
                <td>{{ orderInfo.cellNum }}</td>
              </tr>
              <tr>
                <td class="th">주소</td>
                <td>
                  {{ orderInfo.addrPost }}
                  <br />
                  {{ orderInfo.addrRoad }}
                  <br />
                  {{ orderInfo.addrRemark }}
                </td>
              </tr>
              <tr v-if="orderInfo.releaseClass == 'RDET0001'">
                <td class="th">희망설치일</td>
                <td>{{ orderInfo.installReqDate }}</td>
              </tr>
              <tr>
                <td class="th">배송메모</td>
                <td>{{ orderInfo.userDeliveryMemo }}</td>
              </tr>
            </tbody>
          </table>
          <!-- table (e) -->
        </section>

        <!-- 결제 정보 렌탈 -->
        <section class="hr" v-if="orderInfo.saleType == 'RORT00GE'">
          <div class="titArea mt0">
            <h2 class="titH4">결제 정보</h2>
          </div>
          <table class="tableY noLine bbNone">
            <colgroup>
              <col style="width:110px" />
              <col style="width:auto" />
            </colgroup>
            <tbody>
              <tr>
                <td class="th">결제 수단</td>
                <td v-if="orderInfo.checkType == 'RDUT00CC'">
                  {{ orderInfo.cardNameNm }}
                  <br />
                  {{ orderInfo.cardNumber }}
                </td>
                <td v-else>{{ orderInfo.bankCodeNm + ' ' }}{{ orderInfo.bankAccnt }}</td>
              </tr>
              <tr>
                <td class="th">결제일</td>
                <td>매월 {{ orderInfo.dueDate }}일</td>
              </tr>
            </tbody>
          </table>
        </section>

        <!-- 결제 정보 구매 -->
        <section class="hr" v-if="orderInfo.saleType == 'RORT00SE'">
          <div class="titArea mt0">
            <h2 class="titH4">결제 정보</h2>
            <!-- <button
              type="button"
              class="links"
              @click="cancelPayment"
              v-if="
                orderInfo.trackDeliveryYn != 'Y' &&
                  (orderInfo.dispStatus == 'releaseReady' || orderInfo.dispStatus == 'reqComp' || orderInfo.dispStatus == 'reqIng') &&
                  cancelYn
              "
            >
              결제취소
            </button> -->
          </div>
          <table class="tableY noLine bbNone ar">
            <colgroup>
              <col style="width:110px" />
              <col style="width:auto" />
            </colgroup>
            <tbody>
              <tr>
                <td class="th">주문금액</td>
                <td>
                  <span>{{ orderInfo.onePaySaleAmount | currency }}</span>
                  원
                </td>
              </tr>
              <tr>
                <td class="th">배송비</td>
                <td>
                  +
                  <span>0</span>
                  원
                </td>
              </tr>
              <tr>
                <td class="th">결제 금액</td>
                <td>
                  <span class="money pointC1">
                    <em>{{ orderInfo.onePayAmount | currency }}</em>
                    원
                  </span>
                  <p class="txtXS pointC6 mt5 ar">
                    <i>{{ orderInfo.onePayCardName }}</i>
                    <i>[{{ orderInfo.onePayQuota }}]</i>
                    /
                    <i>{{ orderInfo.onePayDate }}</i>
                  </p>
                  <!-- 일시불 카드 결제만 존재.
                  <p class="txtXS pointC6 mt5 ar" v-else>
                    <i>{{ orderInfo.bankCodeNm + ' ' }}{{ orderInfo.bankAccnt }}</i>
                  </p> -->
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="centerYn" class="txtXS mt5 ar">
            * 결제취소는 상담원을 통해 가능합니다. (고객센터
            <span @click="tel" style="color: blue">1670-0202</span>
            )
          </div>
        </section>

        <section
          class="hr"
          v-if="
            orderInfo.saleType == 'RORT00SE' &&
              (orderInfo.dispStatus == 'cancelComp' || orderInfo.dispStatus == 'cancelReq') &&
              orderInfo.refundPayAmount > 0
          "
        >
          <div class="titArea">
            <h2 class="titH4">환불 정보</h2>
          </div>
          <table class="tableY noLine bbNone ar">
            <colgroup>
              <col style="width:90px" />
              <col style="width:auto" />
            </colgroup>
            <tbody>
              <tr>
                <td class="th">주문금액</td>
                <td>
                  <span>{{ orderInfo.refundSaleAmount | currency }}</span>
                  원
                </td>
              </tr>
              <tr>
                <td class="th">배송비</td>
                <td>
                  +
                  <span>0</span>
                  원
                </td>
              </tr>
              <tr>
                <td class="th">쿠폰할인차감</td>
                <td>
                  -
                  <span>{{ orderInfo.refundDiscountAmount | currency }}</span>
                  원
                </td>
              </tr>
              <tr>
                <td class="th vb">
                  <span class="pointC1">환불예상금액</span>
                  <br />
                  <p class="txtXS pointC6 mt5">환불 수단</p>
                </td>
                <td class="vb">
                  <span class="money pointC1">
                    <em>{{ orderInfo.refundPayAmount | currency }}</em>
                    원
                  </span>
                  <p class="txtXS pointC6 mt5 ar">
                    <i>{{ orderInfo.refundCardName }}</i>
                    <i>[{{ orderInfo.refundQuota }}]</i>
                    /
                    <i>{{ orderInfo.refundRequestDate }}</i>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </section>

        <CommonBanner></CommonBanner>
        <ConfirmPop v-if="confirmPop" @confirm="confirm" @cancel="cancel" @close="confirmPop = false">
          <p v-html="msg"></p>
        </ConfirmPop>
        <MessagePop v-if="messagePop" @close="close">
          <p v-html="msg"></p>
        </MessagePop>
        <QuickMenu></QuickMenu>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <!-- <Delivery></Delivery> -->
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import CommonBanner from '@/components/banner/CommonBanner';
import ConfirmPop from '@/components/popup/ConfirmPop';
import MessagePop from '@/components/popup/MessagePop';
import QuickMenu from '@/views/app/comm/QuickMenu';

export default {
  name: 'guestOrderList',
  components: {
    CommonBanner,
    ConfirmPop,
    MessagePop,
    QuickMenu,
  },
  mounted() {
    this.selectOrderNonmemberByorderIdandMobileByCellNum();
  },
  data() {
    return {
      headerTitle: '주문상세보기',
      msg: null,
      confirmPop: null,
      messagePop: false,

      orderId: this.$route.params.orderId,
      cellNum: this.$route.params.cellNum,

      orderInfo: {},

      productObj: {},
      cancelYn: false,
      centerYn: false,
    };
  },
  methods: {
    selectOrderNonmemberByorderIdandMobileByCellNum() {
      ApiService.service('GET', 'order/nonmember/' + this.orderId + '/mobile/' + this.cellNum)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.orderInfo = data.result;
            const date = this.$moment(new Date()).format('YYYYMMDD');
            const onePayDate = this.$moment(this.orderInfo.onePayDate).format('YYYYMMDD');
            if (onePayDate == date && this.orderInfo.status == 'RSTA00RP') this.cancelYn = true;
            if (onePayDate < date && this.orderInfo.status == 'RSTA00RP') this.centerYn = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    goDelivery() {
      const params = {
        orderId: this.orderInfo.preorderId,
        courierType: this.orderInfo.courierType,
        invoiceNum: this.orderInfo.invoiceNum,
        cellNum: this.orderInfo.cellNum,
        releaseClass: this.orderInfo.releaseClass,
      };

      this.$router.push({ name: 'guestOrderDelivery', params });
    },
    // 렌탈계약서
    goContract() {
      const params = {
        orderId: this.orderInfo.preorderId,
        cellNum: this.orderInfo.cellNum,
      };

      this.$router.push({ name: 'guestOrderContract', params });
    },
    // 유의사항
    goNotice() {
      this.$router.push({ name: 'guestOrderNotice' });
    },
    goProductDetail() {
      if (this.orderInfo.productIndex == '0' || this.orderInfo.discntFlag == 'Y') {
        //this.msg = '없는 상품입니다.';
        //this.messagePop = true;
        return;
      } else {
        this.$router.push('/product/category/detail/' + this.orderInfo.productIndex);
      }
    },
    // 결제취소
    cancelPayment() {
      this.msg = '결제취소 페이지로 이동합니다.';
      this.confirmPop = true;
    },
    confirm: function() {
      const params = {
        orderInfo: this.orderInfo,
      };

      this.$router.push({ name: 'guestOrderCancel', params });
    },
    close() {
      this.messagePop = false;
      this.confirmPop = false;
    },
    cancel: function() {
      this.confirmPop = false;
    },
  },
};
</script>
